import React from 'react';
const seeSteps = ['See the movement.', 'Choose the class.', 'Adapt the level.', 'Start coaching.'];
const negatives = ['No complicated method.', 'No endless searching.', 'No rebuilding everything from scratch.'];
export function SolutionSection() {
  return <section className="bg-petrol text-white px-4 sm:px-6 py-9 sm:py-12" data-id="element-183" data-mp="3jah4bc7x96wc">
      <div className="max-w-3xl mx-auto text-center" data-id="element-184" data-mp="3jcaeh1hqu993">
        <p className="font-heading font-bold text-[9px] sm:text-[11px] uppercase tracking-[0.18em] text-gold mb-2.5" data-id="element-185" data-mp="13j9lzvqoeli">
          Meet Fitness Senior Ready™
        </p>

        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight mb-3.5" data-id="element-186" data-mp="au4hyf17sxhm">
          A visual, ready-to-use coaching system built specifically for{' '}
          <span className="text-lime" data-id="element-187" data-mp="ksbvsp07izfe">older adult fitness.</span>
        </h2>

        <p className="text-[13px] sm:text-base text-white/75 leading-relaxed max-w-xl mx-auto mb-3" data-id="element-188" data-mp="kqh5swa2wh4g">
          Fitness Senior Ready™ brings the practical side of your senior fitness
          programming together in one organized system.
        </p>

        <p className="text-[13px] sm:text-base text-white/75 leading-relaxed max-w-xl mx-auto mb-6" data-id="element-189" data-mp="3baqi95tsdgr0">
          Instead of searching through scattered resources or reading through
          pages of theory just to find something useful, you can quickly access
          visual exercises, complete classes, circuits, activities, progressions
          and programming resources designed for real coaching situations.
        </p>

        <ol className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-5" data-id="element-190" data-mp="3u6qdqqlz32fc">
          {seeSteps.map((step, i) => <li key={step} className="bg-white/[0.06] border border-white/10 rounded-lg px-2 py-3" data-id="element-191" data-mp="2w04bw653w5p" data-mpi={i}>
              <span className="block font-heading font-black text-lime text-base leading-none mb-1" data-id="element-192" data-mp="bv3m8wtkm5im">
                {i + 1}
              </span>
              <span className="font-heading font-bold uppercase text-[9px] sm:text-[11px] tracking-wide leading-snug" data-id="element-193" data-mp="gty4nxnmls27">
                {step}
              </span>
            </li>)}
        </ol>

        <p className="font-heading font-extrabold uppercase text-[11px] sm:text-sm tracking-[0.14em] text-lime mb-4" data-id="element-194" data-mp="27zjgoa2axpip">
          Open it. Choose it. Adapt it. Coach it.
        </p>

        <ul className="flex flex-col sm:flex-row justify-center gap-1 sm:gap-6" data-id="element-195" data-mp="2hv4fy0fzkbor">
          {negatives.map(item => <li key={item} className="text-[11px] sm:text-sm font-semibold text-white/60" data-id="element-196" data-mp="2vpdt4qiplc2f">
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}